import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCart } from '@sola/cart-sdk/store.tsx';
import type { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { useChildSponsorship } from '../../hooks/useChildSponsorship.ts';
import { ChildBioDetailsHeading } from './child-bio-details-heading.tsx';
import { ChildBioInfo } from './child-bio-info.tsx';
import { SubmitButton } from './child-bio-sponsorship-submit-button.tsx';
import { ChildBioSummary } from './child-bio-summary.tsx';
import { ChildBioTabs } from './child-bio-tabs.tsx';
export const ChildBioDetails = t0 => {
  const $ = _c(24);
  const {
    seoLevel: t1,
    details,
    isSticky: t2
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  const isSticky = t2 === undefined ? false : t2;
  useRouter();
  useSearchParams();
  useCart("actions");
  const {
    globalId
  } = details;
  const {
    isSubmitting,
    bioErrors,
    handleSponsorshipSubmit
  } = useChildSponsorship(globalId);
  let t3;
  if ($[0] !== details || $[1] !== isSticky || $[2] !== seoLevel) {
    t3 = <ChildBioDetailsHeading seoLevel={seoLevel} details={details} showIcons={isSticky} />;
    $[0] = details;
    $[1] = isSticky;
    $[2] = seoLevel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] !== details) {
    t4 = <ChildBioSummary details={details} />;
    t5 = <ChildBioInfo details={details} />;
    $[4] = details;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== bioErrors || $[8] !== details || $[9] !== handleSponsorshipSubmit || $[10] !== isSticky || $[11] !== isSubmitting) {
    t6 = <SubmitButton bioErrors={bioErrors} className="mt-comfy-xl" details={details} isSubmitting={isSubmitting} handleSponsorshipSubmit={handleSponsorshipSubmit} isSticky={isSticky} />;
    $[7] = bioErrors;
    $[8] = details;
    $[9] = handleSponsorshipSubmit;
    $[10] = isSticky;
    $[11] = isSubmitting;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="ChildBioDetails__intro">{t3}{t4}{t5}{t6}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== details || $[19] !== seoLevel) {
    t8 = <div className="ChildBioDetails__content"><ChildBioTabs seoLevel={seoLevel} details={details} /></div>;
    $[18] = details;
    $[19] = seoLevel;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="ChildBioDetails body-md xl:pr-comfy-xl grid gap-roomy-sm">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};